import * as React from "react"

import { readAuthSession, subscribeAuthSession } from "@/lib/auth-token"
import { toRole, type Role } from "@/lib/roles"

export interface Viewer {
  id: string
  role: Role
}

/**
 * Who is signed in, read straight from the session store (a slice may not
 * import `features/auth`). Keyed on id + role, so a token refresh — a new
 * session object for the same person — returns the same value and does not
 * rebuild anything that depends on it.
 */
export function useViewer(): Viewer | null {
  const session = React.useSyncExternalStore(subscribeAuthSession, readAuthSession, () => null)
  const id = session?.user.id ?? null
  const role = toRole(session?.user.role)
  return React.useMemo(() => (id && role ? { id, role } : null), [id, role])
}
